/**
 * Builds WhatsApp / SMS deeplinks with a templated message.
 * Templates support placeholders: {cliente}, {data}, {hora}, {equipe}
 */
import { logError } from "./logger";

function fillTemplate(template, ctx) {
  if (!template) return "";
  return template
    .replaceAll("{cliente}", ctx.cliente || "")
    .replaceAll("{data}", ctx.data || "")
    .replaceAll("{hora}", ctx.hora || "")
    .replaceAll("{equipe}", ctx.equipe || "");
}

function cleanPhone(phone) {
  if (!phone) return "";
  // Strip everything but digits, prepend country code if missing
  let d = String(phone).replace(/\D/g, "");
  if (d.length === 10) d = "1" + d; // US numbers without +1
  return d;
}

export function buildWhatsappLink(phone, message) {
  const num = cleanPhone(phone);
  const text = encodeURIComponent(message);
  return `https://wa.me/${num}?text=${text}`;
}

export function buildSmsLink(phone, message) {
  const num = cleanPhone(phone);
  const text = encodeURIComponent(message);
  // iOS/Android compatible
  return `sms:+${num}?&body=${text}`;
}

export function buildMessage(template, { client, job, team }) {
  let dateStr = "";
  let timeStr = "";
  if (job?.scheduled_at) {
    try {
      const d = new Date(job.scheduled_at);
      dateStr = d.toLocaleDateString("en-US");
      timeStr = d.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      logError("Invalid scheduled_at date for notify message:", job.scheduled_at, e);
    }
  }
  return fillTemplate(template, {
    cliente: client?.name || "",
    data: dateStr,
    hora: timeStr,
    equipe: team?.name || "",
  });
}
